require("!!/Users/gautierfauchart/Ethereum/Ethdev-RPS/node_modules/script-loader/addScript.js")(require("!!/Users/gautierfauchart/Ethereum/Ethdev-RPS/node_modules/raw-loader/index.js!/Users/gautierfauchart/Ethereum/Ethdev-RPS/node_modules/phaser-ce/build/custom/pixi.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/phaser-ce/build/custom/pixi.js
// module id = 93
// module chunks = 3